module.exports = __webpack_public_path__ + "static/stratHero-51bf64513cf183da73975541a2ab1b09.png";